// @ts-nocheck
/**
 * mobx-react compatibility shim — replaces mobx-react's `inject`, `observer`,
 * and `Provider` with zustand-backed equivalents so the existing class
 * components can use `@inject('store') @observer` decorators unchanged.
 *
 *   import { inject, observer } from '<path to>/stores/mobx-compat';
 *
 * `inject('store')` injects a `store` prop matching the old MobX root shape
 * and re-renders the component on any store change.
 *
 * `observer` is identity — re-rendering happens through `inject` which uses
 * `useSyncExternalStore` under the hood.
 */
import React from 'react';
import { withStore } from './index';

export const observer = (Component) => Component;

export const inject = (...names) => (Component) => {
  // The MobX `inject('store')` pattern is the only call site in this app;
  // we always inject the full zustand root as `store`.
  if (names.length === 0 || !names.includes('store')) return Component;
  return withStore(Component);
};

export const Provider = ({ children }) => children;
